"use strict";

export default {
  EINWILLIGUNG: "32db8452-a183-48f8-9b49-1f4b139ea220",
  WIDERRUF: "bd6140ca-f12a-42cb-a818-433be3e7ed1e"
};
